/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "./case-practice-ts.component.css.shim.ngstyle";
import * as i1 from "@angular/core";
import * as i2 from "../case-practice-ts-list/case-practice-ts-list.component.ngfactory";
import * as i3 from "../case-practice-ts-list/case-practice-ts-list.component";
import * as i4 from "../common.service";
import * as i5 from "@angular/common";
import * as i6 from "../api.service";
import * as i7 from "@angular/router";
import * as i8 from "../tokenService.service";
import * as i9 from "./case-practice-ts.component";
var styles_CasePracticeTsComponent = [i0.styles];
var RenderType_CasePracticeTsComponent = i1.ɵcrt({ encapsulation: 0, styles: styles_CasePracticeTsComponent, data: {} });
export { RenderType_CasePracticeTsComponent as RenderType_CasePracticeTsComponent };
export function View_CasePracticeTsComponent_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "app-case-practice-ts-list", [], null, null, null, i2.View_CasePracticeTsListComponent_0, i2.RenderType_CasePracticeTsListComponent)), i1.ɵdid(1, 4308992, null, 0, i3.CasePracticeTsListComponent, [i4.CommonService, i5.PlatformLocation, i6.ApiService, i7.ActivatedRoute, i8.TokenService, i7.Router], null, null), (_l()(), i1.ɵted(-1, null, ["\n"]))], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
export function View_CasePracticeTsComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "app-case-practice-ts", [], null, null, null, View_CasePracticeTsComponent_0, RenderType_CasePracticeTsComponent)), i1.ɵdid(1, 114688, null, 0, i9.CasePracticeTsComponent, [], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var CasePracticeTsComponentNgFactory = i1.ɵccf("app-case-practice-ts", i9.CasePracticeTsComponent, View_CasePracticeTsComponent_Host_0, {}, {}, []);
export { CasePracticeTsComponentNgFactory as CasePracticeTsComponentNgFactory };



// WEBPACK FOOTER //
// ./src/app/case-practice-ts/case-practice-ts.component.ngfactory.js.pre-build-optimizer.js